import { AppBar, Dialog, DialogContent, IconButton, Toolbar, Tooltip, Typography } from '@material-ui/core';
import React from 'react';
import { Close } from '@material-ui/icons';
import { PDFDownloadLink } from '@react-pdf/renderer';
import PumpingStationQrCodeDocument from '../pdf/QrCodeDocument';
import PumpingStationHelper, { IPumpingStation } from '../../../@types/model/pumpingStation/pumpingStation';
import QrCodeService from '../../../services/qrCodeService';
import { Ecc } from '../../../@types/qrcodegen';
import StadiumButton from '../../customComponents/button/StadiumButton';
import { Transitions } from '../../customComponents/animations/Transitions';
import AppFunctionsService from '../../../services/appFunctionsService';

interface IPumpingStationDownloadQrCodeButtonProps {
    value : IPumpingStation;

    onClose ?: () => void;
}

interface IPumpingStationDownloadQrCodeButtonState {
    open : boolean;
}

export default class PumpingStationDownloadQrCodeButton extends React.PureComponent<IPumpingStationDownloadQrCodeButtonProps, IPumpingStationDownloadQrCodeButtonState> {
    private readonly canvasRef : React.RefObject<HTMLCanvasElement>;
    constructor(props : IPumpingStationDownloadQrCodeButtonProps) {
        super(props);
        this.state = {
            open: false,
        };

        this.canvasRef = React.createRef();
    }

    private readonly onRendered = () => {
        if (!this.canvasRef.current) return;

        QrCodeService.drawOnCanvas(this.canvasRef.current, {
            ecc: Ecc.HIGH,
            text: PumpingStationHelper.getQrCodeText(this.props.value),
            scale: 4,
        });
    };

    private readonly onClick = () => {
        this.setState({
            open: true,
        });
    };

    private readonly onClose = () => {
        this.setState({
            open: false,
        });
    };
    
    public readonly render = () => {
        const {
            value,
        } = this.props;

        const {
            open,
        } = this.state;

        return (
            <React.Fragment>
                <Tooltip title='DownloadQrCode'>
                    <div>
                        <StadiumButton className='fw500 fs14 cp bcy' variant='contained' onClick={this.onClick}>
                            DOWNLOAD QR CODE
                        </StadiumButton>
                    </div>
                </Tooltip>
                <Dialog
                    open={open}
                    TransitionComponent={Transitions.ZoomIn}
                    transitionDuration={500}
                    maxWidth={'sm'}
                    fullWidth
                    aria-labelledby='archive-tree-dialog-title'
                    aria-describedby='archive-tree-description'
                    onRendered={this.onRendered}>
                    <AppBar className='fdr posr aic jcc bcpd' position='static'>
                        <Toolbar className={'fdr flx1 aic jcc'}>
                            <Typography>
                                DOWNLOAD QR CODE
                            </Typography>
                            <span className='flx1' />
                            <Tooltip title='Close'>
                                <div>
                                    <IconButton color='inherit' onClick={this.onClose} aria-label='Close'>
                                        <Close />
                                    </IconButton>
                                </div>
                            </Tooltip>
                        </Toolbar>
                    </AppBar>
                    <DialogContent>
                        <div className='fdc'>
                            <div className='fdc aic jcc'>
                                <canvas
                                    ref={this.canvasRef}
                                    width={808}
                                    height={800}
                                />
                            </div>
                            <div className='fdc aic jcc mt15'>
                                <Typography
                                    className='fs15 fwm cg3'
                                >
                                    {value.code}
                                </Typography>
                                <Typography
                                    className='fs15 fwm cg3'
                                >
                                    {AppFunctionsService.toTitleCase(value.name)}
                                </Typography>
                            </div>
                            <div className='fdc aife jcc mt15'>
                                <PDFDownloadLink
                                    document={
                                        <PumpingStationQrCodeDocument
                                            pumpingStations={[value]}
                                        />
                                    }
                                    fileName={`${value.code}.pdf`}
                                    className={'tdn'}
                                >
                                    {
                                        ({
                                            loading,
                                        }) => (
                                            <Tooltip title='Download'>
                                                <div>
                                                    <StadiumButton
                                                        disabled={loading}
                                                        variant='contained'
                                                        className='fw500 fs14 cw bcp'
                                                        onClick={this.onClick}
                                                    >
                                                        DOWNLOAD
                                                    </StadiumButton>
                                                </div>
                                            </Tooltip>
                                        )
                                    }
                                </PDFDownloadLink>
                            </div>
                        </div>
                    </DialogContent>
                </Dialog>
            </React.Fragment>
        );
    };
}
